import * as React from 'react'

import { Box, ExpandableContainer, Text } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import TextInput from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

interface Props {
  open: boolean
  header: React.ReactNode
  field?: Field
  value?: string
  onChange?: (field: Field) => void
}

const ContainerComponent = ({ open, header, field, value, onChange }: Props) => {
  return (
    <FormRow>
      <ExpandableContainer header={header} open={open}>
        {field && (
          <FormRow>
            <Box
              flexDirection="row"
              alignItems="baseline"
              gap="s8"
              background="grey200"
              padding="s24"
            >
              <Box width="s200">
                <TextInput type="number" field={field} value={value} onChange={onChange} min={0} />
              </Box>
              <Text.Normal size="200">
                {i18n.t(
                  'app_store_v2.apps.employee_onboarding.settings_default_date.container_text'
                )}
              </Text.Normal>
            </Box>
          </FormRow>
        )}
      </ExpandableContainer>
    </FormRow>
  )
}

export default observer(ContainerComponent)
